import { render, staticRenderFns } from "./login-pop.vue?vue&type=template&id=49ae5cf7&scoped=true"
import script from "./login-pop.vue?vue&type=script&lang=ts"
export * from "./login-pop.vue?vue&type=script&lang=ts"
import style0 from "./login-pop.vue?vue&type=style&index=0&id=49ae5cf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ae5cf7",
  null
  
)

export default component.exports